import * as React from "react";
import styles from "./styles.scss";

const Label = (props: React.PropsWithChildren<unknown>) => {
  return <span className={styles.label}>{props.children}</span>;
};

export default Label;
